import {
  ListMemberRole_default
} from "./chunk-7S44IXL6.js";
import {
  MemberRoleViewModelContextProvider
} from "./chunk-N5PAYPRJ.js";

// src/pages/MemberRole/index.tsx
import React from "react";
import { observer } from "mobx-react";
var MemberRolePage = observer(
  class MemberRolePage2 extends React.Component {
    constructor(props) {
      super(props);
    }
    render() {
      return /* @__PURE__ */ React.createElement("div", { className: "px-3 py-4" }, /* @__PURE__ */ React.createElement(MemberRoleViewModelContextProvider, null, /* @__PURE__ */ React.createElement(ListMemberRole_default, null)));
    }
  }
);

export {
  MemberRolePage
};
